import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  settings: null,
};

export const companySettingSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings: (state, actions) => {
      state.settings = actions.payload;
    },
  },
});

export const { setSettings } = companySettingSlice.actions;

export default companySettingSlice.reducer;
